import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { EXIT_STOCK_UNIT } from "../stock-unit.queries";
import {
  ExitStockUnitMutation,
  ExitStockUnitMutationVariables,
} from "../../../__generated__/ExitStockUnitMutation";

export const useExitStockUnit = () => {
  const [mutate, { loading }] = useMutation<
    ExitStockUnitMutation,
    ExitStockUnitMutationVariables
  >(EXIT_STOCK_UNIT, {
    refetchQueries: "active",
  });

  const exit = async (variables: ExitStockUnitMutationVariables) => {
    try {
      const { data } = await mutate({ variables });
      if (!data?.exitStockUnit?.ok) {
        throw Error(data?.exitStockUnit?.error ?? "Error");
      }
      return true;
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
      return false;
    }
  };

  return { exit, loading };
};
